import React from 'react';
import {getCardHeaderDetails, getOffer} from './contentTiersUtils';
import {IContentTier, IOffers} from '../../types';
import {getCurrency} from '../../utils/dazn/Region';
import localisePrice from '../../utils/localisePrice';
import styles from './content-tiers.module.css';
import classNames from 'classnames';

interface WeeklyTierProps {
    contentTier: IContentTier;
    offers: IOffers | null;
    promoOffers: IOffers | null;
    multiplePromoOffers: IOffers[] | null;
    showWeeklyPlanAtTop?: boolean;
    bottomDividerText?: string;
}

const WeeklyTier: React.FC<WeeklyTierProps> = ({
    contentTier,
    offers,
    promoOffers,
    multiplePromoOffers,
    showWeeklyPlanAtTop = false,
    bottomDividerText
}) => {
    const offerDetail = getOffer({
        offers,
        promoOffers,
        multiplePromoOffers,
        entitlementSetId: contentTier.entitlementSetId,
        billingPeriod: contentTier.billingPeriod,
        billingPlan: '',
        planSelectorShown: false
    });
    const details = getCardHeaderDetails(offerDetail, contentTier);

    const chargeTier = offerDetail?.ChargeTiers?.find(
        (offer) =>
            offer.Currency?.toLocaleLowerCase() ===
            getCurrency()?.toLocaleLowerCase()
    );

    const discountAmount = localisePrice(chargeTier?.Discount?.Price);

    const handleTierButtonClick = () => {
        if (contentTier?.button?.action) {
            contentTier?.button?.action();
        }
    };

    return (
        <>
            {contentTier?.billingPeriod === 'Week' &&
                offerDetail?.BillingPeriod === 'Week' && (
                    <div className={styles.weeklySection}>
                        {!showWeeklyPlanAtTop && (
                            <div className={styles.dividerContainer}>
                                <div className={styles.divider} />
                                <span className={styles.dividerText}>
                                    {contentTier?.dividerText}
                                </span>
                                <div className={styles.divider} />
                            </div>
                        )}

                        <div
                            className={classNames(styles.bottomContainer, {
                                [styles.cardHighlightedAvailable]:
                                    contentTier?.isCardHighlighted,
                                [styles.topContainer]: showWeeklyPlanAtTop
                            })}
                        >
                            {contentTier?.isCardHighlighted && (
                                <div
                                    className={styles.weeklysectioncardEyebrow}
                                >
                                    <span>{contentTier?.eyebrowText}</span>
                                </div>
                            )}
                            <div
                                className={classNames(
                                    styles.weeklyCardDetails,
                                    {
                                        [styles.weeklyCardDetailsHighlight]:
                                            contentTier?.isCardHighlighted
                                    }
                                )}
                            >
                                <div className={styles.contentContainer}>
                                    <div className={styles.headline}>
                                        {contentTier?.title}
                                    </div>
                                    <div className={styles.priceContent}>
                                        {discountAmount != null ? (
                                            <>
                                                <span
                                                    className={
                                                        styles.strikeThrough
                                                    }
                                                >
                                                    {details.price.toString()}
                                                </span>
                                                <span className={styles.price}>
                                                    {discountAmount.toString()}
                                                </span>
                                            </>
                                        ) : (
                                            <span className={styles.price}>
                                                {details.price.toString()}
                                            </span>
                                        )}

                                        <span className={styles.priceText}>
                                            {details.priceLabel}
                                        </span>
                                    </div>

                                    <div className={styles.weeklydescription}>
                                        {contentTier?.description}
                                    </div>
                                </div>
                                <div
                                    className={styles.buttonWrapper}
                                    onClick={handleTierButtonClick}
                                >
                                    <button className={styles.button}>
                                        {contentTier?.button?.buttonLabel}
                                    </button>
                                </div>
                            </div>
                        </div>
                        {showWeeklyPlanAtTop && (
                            <div className={styles.dividerContainerTop}>
                                <div className={styles.divider} />
                                <span className={styles.dividerText}>
                                    {bottomDividerText}
                                </span>
                                <div className={styles.divider} />
                            </div>
                        )}
                    </div>
                )}
        </>
    );
};

export default WeeklyTier;
